import { TranslateResult } from 'vue-i18n'
import { CompetenceRow, DetailRow, JobsRow, LevelOfEducationRow, SpecializationRow } from '@/types/service-response'
import { QcqDialogData, QcqDialogRow, UiLanguageItem } from '@/types'
import store from '@/store'
import { QcqOperations } from '@/types/enums'
import i18n from '@/i18n'
import _ from 'lodash'

export function createDetailDialogData (responseData: Array<DetailRow>, operation: number): QcqDialogData {
  const dialogRows: Array<QcqDialogRow> = []
  const uiLanguageList = store.state.uiLanguageList
  const descriptionMap: Map<string, string> = new Map()

  descriptionMap.set('en', responseData[0].DetailBezeichnungEN)
  descriptionMap.set('de', responseData[0].DetailBezeichnungDE)
  descriptionMap.set('it', responseData[0].DetailBezeichnungIT)
  descriptionMap.set('fr', responseData[0].DetailBezeichnungFR)
  descriptionMap.set('pt', responseData[0].DetailBezeichnungPT)

  _.orderBy(uiLanguageList,['syzId'],['asc']).forEach((item: UiLanguageItem) => {
    let description
    if (operation !== QcqOperations.ADD) {
      description = descriptionMap.get(item.code)
    }

    dialogRows.push({
      language: item.code,
      description: description || ''
    })
  })

  return {
    id: responseData[0].DetailID,
    code: operation === QcqOperations.ADD ? '' : responseData[0].DetailCode,
    language: responseData[0].SpracheID,
    rows: dialogRows
  }
}

export function createCompetenceDialogData (responseData: Array<CompetenceRow>, operation: number): QcqDialogData {
  const dialogRows: Array<QcqDialogRow> = []
  const uiLanguageList = store.state.uiLanguageList
  const descriptionMap: Map<string, string> = new Map()

  descriptionMap.set('en', responseData[0].CompetenceBezeichnungEN)
  descriptionMap.set('de', responseData[0].CompetenceBezeichnungDE)
  descriptionMap.set('it', responseData[0].CompetenceBezeichnungIT)
  descriptionMap.set('fr', responseData[0].CompetenceBezeichnungFR)
  descriptionMap.set('pt', responseData[0].CompetenceBezeichnungPT)

  _.orderBy(uiLanguageList,['syzId'],['asc']).forEach((item: UiLanguageItem) => {
    let description

    if (operation !== QcqOperations.ADD) {
      description = descriptionMap.get(item.code)
    }

    dialogRows.push({
      language: item.code,
      description: description || ''
    })
  })

  return {
    id: responseData[0].CompetenceID,
    code: operation === QcqOperations.ADD ? '' : responseData[0].CompetenceCode,
    language: responseData[0].SpracheID,
    rows: dialogRows
  }
}

export function createLevelOfEducationDialogData (responseData: Array<LevelOfEducationRow>, operation: number): QcqDialogData {
  const dialogRows: Array<QcqDialogRow> = []
  const uiLanguageList = store.state.uiLanguageList
  const descriptionMap: Map<string, string> = new Map()

  descriptionMap.set('en', responseData[0].BildungsgradeBezeichnungEN)
  descriptionMap.set('de', responseData[0].BildungsgradeBezeichnungDE)
  descriptionMap.set('it', responseData[0].BildungsgradeBezeichnungIT)
  descriptionMap.set('fr', responseData[0].BildungsgradeBezeichnungFR)
  descriptionMap.set('pt', responseData[0].BildungsgradeBezeichnungPT)

  _.orderBy(uiLanguageList,['syzId'],['asc']).forEach((item: UiLanguageItem) => {
    let description

    if (operation !== QcqOperations.ADD) {
      description = descriptionMap.get(item.code)
    }

    dialogRows.push({
      language: item.code,
      description: description || ''
    })
  })

  return {
    id: responseData[0].BildunsgradeID,
    code: operation === QcqOperations.ADD ? '' : responseData[0].BildungsgradeCode,
    language: responseData[0].SpracheID,
    rows: dialogRows
  }
}

export function createJobsDialogData (responseData: Array<JobsRow>, operation: number): QcqDialogData {
  const dialogRows: Array<QcqDialogRow> = []
  const uiLanguageList = store.state.uiLanguageList
  const descriptionMap: Map<string, string> = new Map()

  descriptionMap.set('en', responseData[0].BerufeBezeichnungEN)
  descriptionMap.set('de', responseData[0].BerufeBezeichnungDE)
  descriptionMap.set('it', responseData[0].BerufeBezeichnungIT)
  descriptionMap.set('fr', responseData[0].BerufeBezeichnungFR)
  descriptionMap.set('pt', responseData[0].BerufeBezeichnungPT)

  _.orderBy(uiLanguageList,['syzId'],['asc']).forEach((item: UiLanguageItem) => {
    let description

    if (operation !== QcqOperations.ADD) {
      description = descriptionMap.get(item.code)
    }

    dialogRows.push({
      language: item.code,
      description: description || ''
    })
  })

  return {
    id: responseData[0].BerufeID,
    code: operation === QcqOperations.ADD ? '' : responseData[0].BerufeCode,
    language: responseData[0].SpracheID,
    rows: dialogRows
  }
}

export function createSpecializationDialogData (responseData: Array<SpecializationRow>, operation: number): QcqDialogData {
  const dialogRows: Array<QcqDialogRow> = []
  const uiLanguageList = store.state.uiLanguageList
  const descriptionMap: Map<string, string> = new Map()

  descriptionMap.set('en', responseData[0].FachrichtungenBezeichnungEN)
  descriptionMap.set('de', responseData[0].FachrichtungenBezeichnungDE)
  descriptionMap.set('it', responseData[0].FachrichtungenBezeichnungIT)
  descriptionMap.set('fr', responseData[0].FachrichtungenBezeichnungFR)
  descriptionMap.set('pt', responseData[0].FachrichtungenBezeichnungPT)

  _.orderBy(uiLanguageList,['syzId'],['asc']).forEach((item: UiLanguageItem) => {
    let description

    if (operation !== QcqOperations.ADD) {
      description = descriptionMap.get(item.code)
    }

    dialogRows.push({
      language: item.code,
      description: description || ''
    })
  })

  return {
    id: responseData[0].FachrichtungenID,
    code: operation === QcqOperations.ADD ? '' : responseData[0].FachrichtungenCode,
    language: responseData[0].SpracheID,
    rows: dialogRows
  }
}

export function createDialogTitleForOperation (operation: QcqOperations, specificAddTitle: TranslateResult): string {
  let title: TranslateResult

  switch (operation) {
    case QcqOperations.ADD:
      title = specificAddTitle
      break

    case QcqOperations.REMOVE:
      title = specificAddTitle
      break

    default:
      title = i18n.t('qcqDialogComponent.edit')
  }

  return title.toString()
}

export function createSnackbarMessageForOperation (operation: QcqOperations, specificSnackbarMessage: TranslateResult): string {
  let snackbarMessage: TranslateResult

  switch (operation) {
    case QcqOperations.ADD:
      snackbarMessage = specificSnackbarMessage
      break

    case QcqOperations.EDIT:
      snackbarMessage = specificSnackbarMessage
      break

    case QcqOperations.REMOVE:
      snackbarMessage = specificSnackbarMessage
      break

    default:
      snackbarMessage = i18n.t('qcqQualificationPage.dataWasSaved')

  }

  return snackbarMessage.toString()
}
